import { render, staticRenderFns } from "./VoiceBar.vue?vue&type=template&id=b2eeea76&scoped=true"
import script from "./VoiceBar.vue?vue&type=script&lang=js"
export * from "./VoiceBar.vue?vue&type=script&lang=js"
import style0 from "./VoiceBar.vue?vue&type=style&index=0&id=b2eeea76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eeea76",
  null
  
)

export default component.exports